
import { useLocalStorageSync } from '../../shared/hooks/useLocalStorageSync';
import { useCallback } from 'react';
import { dataStorageService } from '../../shared/services/dataStorageService';
import { appConstants } from '../../shared/constants/appConstants';

const HASH_A_KEY = 'auth_hash_a';
const HASH_B_KEY = 'auth_hash_b';

/**
 * Hook to manage authentication state.
 * persistent store for Hash_A and Hash_B only.
 */
export const useAuthStore = () => {
    const [hashA, setHashA] = useLocalStorageSync(HASH_A_KEY, null);
    const [hashB, setHashB] = useLocalStorageSync(HASH_B_KEY, null);

    const login = useCallback((a, b) => {
        setHashA(a);
        setHashB(b);
    }, [setHashA, setHashB]);

    const logout = useCallback(async () => {
        setHashA(null);
        setHashB(null);
        await dataStorageService.clearData();
        localStorage.removeItem(appConstants.localStorageMetaPrefix + 'versions');
    }, [setHashA, setHashB]);

    const isAuthorized = !!(hashA && hashB);

    return {
        hashA,
        hashB,
        isAuthorized,
        login,
        logout
    };
};
